import { render } from "./TrendsReportGraph.vue?vue&type=template&id=6d12232a&scoped=true"
import script from "./TrendsReportGraph.vue?vue&type=script&lang=js"
export * from "./TrendsReportGraph.vue?vue&type=script&lang=js"

import "./TrendsReportGraph.vue?vue&type=style&index=0&id=6d12232a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d12232a"]])

export default __exports__